import { Spinner } from '@change/ds-core-ui';

import { withPrefetchedData } from 'src/shared/prefetch';

import type { ImpactPagePrefetchedDataProps } from 'src/app/pages/about/impact/pageContext';
import { ImpactPageContextProvider, prefetchPageContext } from 'src/app/pages/about/impact/pageContext';
import { OG_IMAGE } from 'src/app/pages/about/impact/shared/consts';

import { Layout } from '../layout';

import { ImpactErrorHandler } from './ErrorHandler';

export const Impact = withPrefetchedData(
	function Impact({ prefetchedData }: ImpactPagePrefetchedDataProps) {
		return (
			<ImpactPageContextProvider
				prefetchedData={prefetchedData}
				errorHandler={ImpactErrorHandler}
				loadingFallback={<Spinner className="mx-auto my-64" />}
			>
				<Layout />
			</ImpactPageContextProvider>
		);
	},
	{
		prefetchName: __MODULE_HASH__,
		prefetchData: async (context) => prefetchPageContext(context),
		pageTitle: ({ i18n, fromTemplate }) => fromTemplate(i18n.translate('fe.pages.impact.title_tag')),
		pageMetadata: ({ i18n }) => {
			const title = i18n.translate('fe.pages.impact.victories.every_hour');
			const description = i18n.translate('fe.pages.about.section_victories.description');
			return {
				ogTitle: title,
				ogDescription: description,
				ogImage: OG_IMAGE,
				ogType: 'website',
				twitterCard: 'summary',
				twitterImage: OG_IMAGE,
				twitterImageAlt: title,
			};
		},
	},
);
